import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Button } from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import pagination from "~/components/pagination/currentSizePerPage/10";
import UploadButton from "~/components/Buttons/UploadButton";

const Table = ({ columns, dataList, setModalNew, t }) => {
  const { SearchBar } = Search;

  const handleCreate = () => {
    setModalNew(true);
  };

  return (
    <div className="custom-table withoutOverflow">
      <ToolkitProvider
        keyField="id"
        data={dataList}
        columns={columns}
        search={{ searchFormatted: true }}
      >
        {(props) => (
          <div>
            <div style={{ paddingBottom: "20px", display: "flex" }}>
              <SearchBar
                {...props.searchProps}
                placeholder={t("portalrh.rhadmin.gestaoTemplates.searchInput")}
              />
              <div style={{ paddingLeft: "30px" }}>
                <UploadButton
                  id={"button_cvmanagement_concursos_add"}
                  text={"Adicionar Novo Encargo"}
                  onClick={handleCreate}
                />
              </div>
            </div>
            <BootstrapTable
              {...props.baseProps}
              id="document-table"
              responsive
              bootstrap4
              pagination={paginationFactory(pagination)}
              noDataIndication={t("datacapture.general.dataNotFound")}
              pageSize={10}
              hover
              striped
            />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default withNamespaces()(Table);
